<template>
  <v-layout align-center>
    <v-flex xs12 sm10 md8>
      <v-layout wrap>
        <v-flex xs12>
          <form v-scroll-to-error @submit.prevent="submitForm">
            <div class="screen-title mb-0">
              <span>{{ adminText('workflowsAll.create_hall_7f9d058', 'Create Hall') }}</span>
            </div>
            <div class="mb-32 title-description">
              {{ adminText('workflowsAll.you_need_to_provide_information_about_your_ne_81605d8', 'You need to provide information about your new hall.') }}
            </div>
            <hall-form
              :vs="$v"
              :initial-values="form"
              :event-id="eventId"
              @values="form=$event"
            />
            <main-button
              :text="adminText('workflowsAll.create_6e157c5', 'Create')"
              depressed
              @click="$emit('submit')"
            />
            <main-button
              :text="adminText('workflowsAll.cancel_77dfd21', 'Cancel')"
              flat
              @click.prevent="goBack"
            />
          </form>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'

import HallForm from './hall-form.vue'
import MainButton from './../shared/main-button.vue'
import {createHall} from './../../http'

import { required } from 'vuelidate/lib/validators'
import { submitGuard } from './../../utils'

export default {
  mixins: [WorkflowDisplay],
  name: 'new-hall-container',
  components: {
    HallForm,
    MainButton,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
  },
  validations() {
    return {
      form: {
        name: { required },
      },
    }
  },
  data: () => ({
    form: {},
  }),
  methods:{
    async submitForm() {
      await submitGuard(this, async () =>{
        await createHall({
          eventId: this.eventId,
          input: {
            name: this.form.name,
            color: this.form.color,
            image: this.form.image,
          },
        })
        this.goBack()
      })
    },
  },
}
</script>

<style>
</style>
